import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { ProjectsAccessGuard } from 'modules/projects/components/ProjectsAccessGuard';
import { chainsRoutesConfig } from 'domains/chains/routes';

import { useProjectsPageLoader } from '../../hooks';

const EditProjectStepPageV2 = loadable(
  async () => {
    const module = await import('./EditProjectStepPageV2');

    return module.EditProjectStepPageV2;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsPath = chainsRoutesConfig.chains.generatePath();

function EditProjectStepPageV2Loader() {
  const { isLoading, shouldForceRedirect } = useProjectsPageLoader();

  if (isLoading) {
    return <OverlaySpinner />;
  }

  return (
    <GuardAccountPermission
      permission={AccountPermission.UsageData}
      shouldForceRedirect={shouldForceRedirect}
      shouldHideAlert
      shouldRedirect
    >
      <ProjectsAccessGuard fallback={chainsRoutesConfig.chains.generatePath()}>
        <EditProjectStepPageV2 />
      </ProjectsAccessGuard>
    </GuardAccountPermission>
  );
}

export const EditProjectStepPageV2Container = () => {
  return (
    <Page>
      <NoSSRGuard>
        <LoggingInGuard fallback={<Navigate to={chainsPath} />}>
          <EditProjectStepPageV2Loader />
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
